import { Padding as LibraryPadding } from '@mercator-gcp/grout';

export const padding = {
  ...LibraryPadding,
  // deprecate
  two: '2px',
  four: '4px',
  eight: '8px',
  twelve: '12px',
  sixteen: '16px',
  twentyFour: '24px',
  thirtyTwo: '32px',
  fortyEight: '48px',
  sixtyFour: '64px',
  ninetySix: '96px',
  oneSixty: '160px',
};
